const brushSVG =
  '<svg t="1587883909986" class="icon" viewBox="0 0 1025 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12256" width="22" height="22"><path d="M286.083607 621.781768S154.021425 692.892174 148.94211 809.716412C143.862795 921.461335 37.197187 1007.809684 1.641984 1017.968314c-35.555203 10.158629 523.169413 35.555203 482.534895-208.251902l-198.093272-187.934644zM397.82853 565.909306c-20.317259-20.317259-45.713832-25.396573-60.951777-10.158629-15.237944 15.237944-10.158629 40.634518 10.15863 60.951776l132.062182 132.062182c20.317259 20.317259 45.713832 25.396573 60.951776 10.15863 15.237944-15.237944 10.158629-40.634518-10.158629-60.951777l-132.062182-132.062182zM997.187663 12.264005c-35.555203-25.396573-71.110406-5.079315-81.269035 5.079315-40.634518 30.475888-345.393399 325.07614-472.376266 462.217637-15.237944 20.317259-25.396573 40.634518 50.793147 116.824238 66.031091 66.031091 96.506979 60.951776 126.982867 35.555202 55.872462-55.872462 289.520937-386.027916 375.869287-513.010783 10.158629-20.317259 40.634518-76.18972 0-106.665609z" p-id="12257" fill="#707070"></path></svg>'

// 笔刷
class Brush {
  constructor({ frontCanvasEl, frontCanvasCtx, mainCanvasCtx, isHost }) {
    // 接收传递的 mainCanvasCtx
    this.frontCanvasEl = frontCanvasEl
    this.frontCanvasCtx = frontCanvasCtx
    this.mainCanvasCtx = mainCanvasCtx
    this.dpr = window.devicePixelRatio

    // 定义笔刷属性
    this.lineWidth = 3 // 画笔默认线宽  tip直径
    this.lineWidthRange = [2, 40]
    this.color = 'red' // 默认颜色
    this.linePathList = [] // 画笔路径坐标数组

    // 暴露btn
    this.btnEl = document.createElement('button')
    this.btnEl.innerHTML = brushSVG

    // 暴露option
    this.optionEl = document.querySelector('.size-option') //document.createElement('div');

    // 定义size标识
    this.tipEl = this.optionEl.querySelector('.tip')

    // const sizeSliderEl = new SizeSlider({
    //   ratio: (this.lineWidth - this.lineWidthRange[0]) / (this.lineWidthRange[1] - this.lineWidthRange[0]),
    //   sliderSize: 30
    // }).El;
    // sizeSliderEl.addEventListener('sliderChange', (e) => {
    //   const size = (this.lineWidthRange[1] - this.lineWidthRange[0]) * e.detail + this.lineWidthRange[0];
    //   this.sizeChange(size)
    // })
    // this.optionEl.querySelector('.sizeSliderBox').appendChild(sizeSliderEl);

    // const colorSliderEl = new ColorSlider({}).El;
    // colorSliderEl.addEventListener('colorSliderChange', (e) => {
    //   this.colorChange(e.detail);
    // })

    // this.optionEl.querySelector('.colorOption').appendChild(colorSliderEl);

    this.sizeChange(this.lineWidth)
    this.colorChange(this.color)
  }
  sizeChange(size) {
    this.lineWidth = size
    this.tipEl.style.width = size + 'px'
    this.tipEl.style.height = size + 'px'
  }
  colorChange(color) {
    this.color = color
    this.tipEl.style.backgroundColor = color
  }
  drawStartFn(e) {
    this.linePathList = []
    this.linePathList.push([e.canvasX, e.canvasY])
    this.render()
  }
  drawMoveFn(e) {
    this.linePathList.push([e.canvasX, e.canvasY])
    this.render()
  }
  drawEndFn(e) {
    const linePathList = [...this.linePathList]
    this.linePathList = []
    const color = this.color
    const lineWidth = this.lineWidth * this.dpr
    return ctx => {
      ctx.save()
      if (linePathList.length === 1) {
        const point = linePathList[0]
        ctx.fillStyle = color
        ctx.beginPath()
        ctx.arc(point[0], point[1], lineWidth / 2, 0, Math.PI * 2, true)
        ctx.closePath()
        ctx.fill()
      } else {
        ctx.strokeStyle = color
        ctx.lineWidth = lineWidth
        // 绘制线段末端的属性-圆形结束
        ctx.lineCap = 'round'
        // 通过填充一个额外的 圆心在相连部分末端的扇形
        ctx.lineJoin = 'round'
        ctx.beginPath()
        ctx.moveTo(linePathList[0][0], linePathList[0][1])
        for (let i = 1; i < linePathList.length; i++) {
          ctx.lineTo(linePathList[i][0], linePathList[i][1])
        }
        ctx.stroke()
      }
      ctx.restore()
    }
  }
  render() {
    const color = this.color
    const lineWidth = this.lineWidth * this.dpr
    const ctx = this.mainCanvasCtx
    ctx.save()
    if (this.linePathList.length === 1) {
      const point = this.linePathList[0]
      ctx.fillStyle = color
      ctx.beginPath()
      // 单点画圆
      ctx.arc(point[0], point[1], lineWidth / 2, 0, Math.PI * 2, true)
      ctx.closePath()
      ctx.fill()
    } else {
      const startPoint = this.linePathList[this.linePathList.length - 2]
      const endPoint = this.linePathList[this.linePathList.length - 1]
      ctx.lineWidth = lineWidth
      ctx.strokeStyle = color
      ctx.lineCap = 'round'
      ctx.lineJoin = 'round'
      ctx.beginPath()
      // 多点画线
      ctx.moveTo(startPoint[0], startPoint[1])
      ctx.lineTo(endPoint[0], endPoint[1])
      ctx.stroke()
    }
    ctx.restore()
  }
  mousemoveFn(e) {
    const ctx = this.frontCanvasCtx
    // ctx.clearRect(0, 0, this.frontCanvasEl.width, this.frontCanvasEl.height)
    ctx.save()
    ctx.beginPath()
    ctx.strokeStyle = this.color
    ctx.lineWidth = 1

    ctx.shadowOffsetX = 2
    ctx.shadowOffsetY = 2
    ctx.shadowBlur = 2
    ctx.shadowColor = 'rgba(0, 0, 0, 0.5)'

    ctx.arc(
      e.canvasX,
      e.canvasY,
      (this.lineWidth / 2) * this.dpr,
      0,
      2 * Math.PI,
      true
    )
    ctx.closePath()
    ctx.stroke()
    ctx.restore()
  }
}

export default Brush
